import { Component } from '@angular/core';
import { FieldGroupTypeConfig, FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-validation-wrapper-component',
  template: `
    <div *ngIf="!field.hide">
      <formly-field *ngFor="let field of field.fieldGroup" [field]="field"></formly-field>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
    <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  `,
  styleUrls: ['./formly-grid-styles.scss']
})
export class FormlyValidationWrapperComponent extends FieldWrapper<FieldGroupTypeConfig> {}
